<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Descontos">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :enableSearch="true"
        :checkAlerts="true"
        :reload="reload"
        @reload="onReloadConsumed"
      >
        <template #header-buttons>
          <CButton color="primary" size="sm" @click="openNovo">
            <fa-icon icon="plus" class="mr-1" /> Novo desconto
          </CButton>
        </template>

        <template v-slot:tipo="{ model }">
          <span :class="badgeRegra(model)">
            <fa-icon :icon="iconeRegra(model)" class="badge-regra__icone" />
            {{ labelRegra(model) }}
          </span>
        </template>

        <template #action-buttons="{ model }">
          <CButton
            size="sm"
            color="primary"
            title="Alterar"
            @click="openEditar(model)"
          >
            <fa-icon icon="pencil-alt" />
          </CButton>
        </template>
      </crud-base>

      <DescontoFormModal
        :editing="editing"
        :dimensoes="dimensoes"
        :opcoesRestricoes="opcoesRestricoes"
        :erroOpcoes="erroOpcoes"
        :tiposFrete="tiposFrete"
        @saved="onSaved"
      />
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import DescontoFormModal from "./DescontoFormModal";
import { get } from "@/helpers/apiRequest";
import { dateFilter } from "@/filters/dateFilter";
import { formatPercent } from "@/filters/monetary";
import { yesNoRepresentation } from "@/helpers/transformers";

const LABEL_TIPO = {
  MIX: "Mix de produtos",
  SEGMENTACAO: "Segmento",
};

const BADGE_TIPO = {
  MIX: "badge badge-primary",
  SEGMENTACAO: "badge badge-info",
};

const ICONE_TIPO = {
  MIX: "shopping-basket",
  SEGMENTACAO: "sliders-h",
};

export default {
  name: "descontos",
  components: {
    CrudBase,
    DescontoFormModal,
  },
  data() {
    return {
      url: "/admin/descontos",
      editing: null,
      reload: false,
      dimensoes: [],
      opcoesRestricoes: {},
      erroOpcoes: false,
      tiposFrete: [],
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "Descrição", field: "descricao", sortable: false },
        { label: "Dt. Início", field: "dtinicio", sortable: false, representedAs: (row) => dateFilter(row.dtinicio) },
        { label: "Dt. Final", field: "dtfim", sortable: false, representedAs: (row) => dateFilter(row.dtfim) },
        { label: "Perc. Desc", field: "percdesconto", sortable: false, representedAs: (row) => formatPercent(row.percdesconto) },
        { label: "Regra", field: "tipo", sortable: false },
        { label: "Ativo", field: "ativo", sortable: false, representedAs: (row) => yesNoRepresentation(row.ativo) },
      ],
    };
  },
  methods: {
    labelRegra(model) {
      return LABEL_TIPO[model.tipo] || "Padrão";
    },
    badgeRegra(model) {
      return BADGE_TIPO[model.tipo] || "badge badge-light";
    },
    iconeRegra(model) {
      return ICONE_TIPO[model.tipo] || "percent";
    },
    /**
     * Dimensoes e opcoes de restricao sao carregadas uma unica vez, no mount:
     * sao as mesmas listas para qualquer desconto e o endpoint de opcoes faz 11
     * consultas (algumas com DISTINCT sobre clientes/produtos ativos, que em
     * base grande passam de 200ms cada). Recarregar a cada abertura de modal so
     * repetiria o custo.
     */
    loadOpcoes() {
      // Mesma fonte do cadastro de campanha comercial: as colunas de dimensao
      // sao as mesmas nos dois cadastros, e `/admin/descontos-dimensoes` nao
      // existe no verso-api (nem na dev) — a chamada voltava 404 e a lista
      // ficava vazia, deixando a regra por segmento sem coluna nenhuma.
      get("/admin/campanhas-dimensoes")
        .then((json) => {
          this.dimensoes = Array.isArray(json) ? json : [];
        })
        .catch(() => {
          this.erroOpcoes = true;
        });

      get("/admin/descontos-opcoes-restricoes")
        .then((json) => {
          this.opcoesRestricoes = json && typeof json === "object" ? json : {};
        })
        .catch(() => {
          this.erroOpcoes = true;
        });

      get("/admin/tipo-frete")
        .then((json) => {
          this.tiposFrete = json && json.items ? json.items : (Array.isArray(json) ? json : []);
        })
        .catch(() => {
          this.tiposFrete = [];
        });
    },
    openNovo() {
      this.editing = null;
      this.$nextTick(() => this.$modal.show('desconto-form'));
    },
    /**
     * A linha da listagem nao traz as condicoes nem o mix da regra por valor:
     * abrir o modal com o registro pela metade faria o salvamento apagar o que
     * nao chegou a ser carregado.
     */
    openEditar(row) {
      get(`/admin/descontos/${encodeURIComponent(row.id)}`)
        .then((json) => {
          if (!json || !json.id) {
            throw new Error('Registro nao retornado');
          }

          this.editing = json;
          this.$nextTick(() => this.$modal.show('desconto-form'));
        })
        .catch(() => {
          new window.swal({
            title: 'Nao foi possivel carregar o desconto',
            text: 'Tente novamente em instantes.',
            icon: 'error',
          });
        });
    },
    onSaved() {
      this.reload = true;
    },
    onReloadConsumed(value) {
      this.reload = value;
    },
  },
  beforeMount() {
    this.loadOpcoes();
  },
};
</script>

<style scoped>
.badge-regra__icone {
  margin-right: 4px;
  font-size: 10px;
}
</style>
